import React from "react";

function Animation() {
  return (
    <div>
      <div className="loading">
        <div className="text-center middle">
          <span className="loader">
            <span className="loader-inner"></span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Animation;
